import { getUrl } from '../config';
import jwtDecode from "jwt-decode";
import { verify, sign } from "jsonwebtoken";
import axios from "axios";

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decoded.exp > currentTime;
};


const setSession = (accessToken) => {
  try {
    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("url", getUrl())
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }
  } catch (error) {
    console.error('Erreur lors de la définition du jeton d\'accès:', error);
  }
};

export { verify, sign, isValidToken, setSession };
